export default __webpack_public_path__ + "static/media/icon-turtle.14a4698c.svg";